import _ from 'lodash'
import _md5 from 'md5'
import constants from './constants'

export default function init() {
  console.log('helpers init')
}

export const checkIfNonCustomActivePlan = parameters => {
  return !parameters['custom.plan.enabled']
}

export function getPlanName(app = '', planNameAsArg = false, source = '') {
  let formattedPlanName = app
  if (planNameAsArg) {
    formattedPlanName = app
  } else if (app.plan !== undefined) {
    formattedPlanName = app.plan
  }
  if (formattedPlanName !== undefined && formattedPlanName !== '') {
    const planID = formattedPlanName

    formattedPlanName = _.startCase(_.split(planID, '-', 1)[0])

    const planName = app.id !== undefined ? app.planName : ''
    if (
      app.id === undefined ||
      planName === undefined ||
      (planName !== undefined && planName.length === 0) ||
      planNameAsArg
    ) {
      if (_.toLower(planID) === 'free-25-(2021-01)') {
        formattedPlanName = 'Expired'
      } else if (_.toLower(planID) === 'free') {
        formattedPlanName = 'Expired'
      } else if (formattedPlanName === 'Trial') {
        formattedPlanName = 'Trial'
      } else if (
        _.includes(constants.nonCustomPlansIDList, planID) &&
        _.includes(constants.allPlanNamesList, formattedPlanName)
      ) {
        if (checkIfPhase6ActivePlan(planID)) {
          if (constants.phase6PlanNameList[planID] !== undefined)
            formattedPlanName = constants.phase6PlanNameList[planID]

          if (app.isAnnual) {
            formattedPlanName = _.join([constants.phase6PlanNameList[planID], '(Annual)'], ' ')
          }
        } else if (checkIfPhase5ActivePlan(planID)) {
          if (constants.phase5PlanNameList[planID] !== undefined)
            formattedPlanName = constants.phase5PlanNameList[planID]
          if (app.isAnnual) {
            formattedPlanName = _.join([constants.phase5PlanNameList[planID], '(Annual)'], ' ')
          }
        } else if (checkIfPhase4ActivePlan(planID)) {
          if (constants.phase4PlanNameList[planID] !== undefined)
            formattedPlanName = _.join([constants.phase4PlanNameList[planID], '(Legacy)'], ' ')
          if (app.isAnnual && source === 'billingTab') {
            formattedPlanName = _.join(
              [constants.phase4PlanNameList[planID], '(Legacy)', '(Annual)'],
              ' ',
            )
          }
        } else if (checkIfPhase3ActivePlan(planID)) {
          if (constants.phase3PlanNameList[planID] !== undefined)
            formattedPlanName = _.join([constants.phase3PlanNameList[planID], '(Legacy)'], ' ')
        } else if (checkIfPhase2ActivePlan(planID)) {
          if (constants.phase2PlanNameList[planID] !== undefined)
            formattedPlanName = _.join([constants.phase2PlanNameList[planID], '(Legacy)'], ' ')
        } else if (checkIfLegacyNonCustomPlan(planID)) {
          formattedPlanName = _.join([formattedPlanName, '(Legacy)'], ' ')
        }
      } else if (
        !_.includes(constants.nonCustomPlansIDList, planID) ||
        !_.includes(constants.allPlanNamesList, formattedPlanName)
      ) {
        formattedPlanName = 'Custom'
      }
    } else {
      formattedPlanName = planName
      if (checkIfPhase5ActivePlan(planID)) {
        formattedPlanName = planName
        if (app.isAnnual) {
          formattedPlanName = _.join([constants.phase5PlanNameList[planID], '(Annual)'], ' ')
        }
      } else if (checkIfPhase4ActivePlan(planID)) {
        if (constants.phase4PlanNameList[planID] !== undefined)
          formattedPlanName = _.join([constants.phase4PlanNameList[planID], '(Legacy)'], ' ')
        if (app.isAnnual && source === 'billingTab') {
          formattedPlanName = _.join(
            [constants.phase4PlanNameList[planID], '(Legacy)', '(Annual)'],
            ' ',
          )
        }
      } else if (checkIfPhase3ActivePlan(planID)) {
        if (constants.phase3PlanNameList[planID] !== undefined)
          formattedPlanName = _.join([constants.phase3PlanNameList[planID], '(Legacy)'], ' ')
      } else if (checkIfPhase2ActivePlan(planID)) {
        if (constants.phase2PlanNameList[planID] !== undefined)
          formattedPlanName = _.join([constants.phase2PlanNameList[planID], '(Legacy)'], ' ')
      } else if (checkIfLegacyNonCustomPlan(planID)) {
        formattedPlanName = _.join([formattedPlanName, '(Legacy)'], ' ')
      }
    }
  }

  if (app.isAnnual) {
    formattedPlanName = `${formattedPlanName}`
  }
  return formattedPlanName
}

export function checkIfCustomPlan(planID = '') {
  let isCustomPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))

    if (
      !_.includes(constants.trialPlansIDList, planID) &&
      !_.includes(constants.nonCustomPlansIDList, planID) &&
      !_.includes(constants.olderPlansIDList, planID)
    ) {
      isCustomPlan = true
    }
  }

  return isCustomPlan
}

export function checkIfTrialOrExpired(planID = '') {
  let isTrialPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.trialPlansIDList, planID)) {
      isTrialPlan = true
    }
  }

  return isTrialPlan
}

export function checkIfPhase2ActivePlan(planID = '') {
  let isPhaseTwoPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.phase2PlansIDList, planID)) {
      isPhaseTwoPlan = true
    }
  }

  return isPhaseTwoPlan
}

export function checkIfLegacyNonCustomPlan(planID = '') {
  let isLegacyNonCustomPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (
      _.includes(constants.legacyNonCustomPlansIDList, planID) ||
      _.includes(constants.phase2PlansIDList, planID)
    ) {
      isLegacyNonCustomPlan = true
    }
  }
  return isLegacyNonCustomPlan
}

export function checkIfCustomOrOldPlan(planID = '') {
  let isCustomPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))

    if (
      !_.includes(constants.trialPlansIDList, planID) &&
      !_.includes(constants.nonCustomPlansIDList, planID)
    ) {
      isCustomPlan = true
    }
  }

  return isCustomPlan
}

export function checkIfCustomOldPlan(planID = '') {
  let isCustomPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))

    if (
      !_.includes(constants.trialPlansIDList, planID) &&
      !_.includes(constants.nonCustomPlansIDList, planID)
    ) {
      isCustomPlan = true
    }
  }
  return isCustomPlan
}

export function getTrialLeftInDays(trialEndsAt = 0, currentTime = Date.now()) {
  let trialDays = 0
  const currentTimestamp = Math.floor(currentTime / 1000)
  if (trialEndsAt && currentTimestamp <= trialEndsAt) {
    const timeRemain = Math.abs(trialEndsAt * 1000 - currentTime)
    trialDays = timeRemain / (1000 * 3600 * 24)
    trialDays = Math.round(trialDays)
  }
  return trialDays
}

export function getFormattedContactNumber(contactNumber = '') {
  let formattedContactNumber = contactNumber
  if (contactNumber !== '') {
    formattedContactNumber = '+91'
  }
  return formattedContactNumber
}

export function getAllCountries() {
  return [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia &amp; Herzegovina',
    'Botswana',
    'Brazil',
    'British Virgin Islands',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Cape Verde',
    'Cayman Islands',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    'Cote D Ivoire',
    'Croatia',
    'Cruise Ship',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Polynesia',
    'French West Indies',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kuwait',
    'Kyrgyz Republic',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Norway',
    'Oman',
    'Pakistan',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Pierre &amp; Miquelon',
    'Samoa',
    'San Marino',
    'Satellite',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'South Africa',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'St Kitts &amp; Nevis',
    'St Lucia',
    'St Vincent',
    'St. Lucia',
    'Sudan',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    "Timor L'Este",
    'Togo',
    'Tonga',
    'Trinidad &amp; Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks &amp; Caicos',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Venezuela',
    'Vietnam',
    'Virgin Islands (US)',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ]
}
export function getCountryCodes() {
  return [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia &amp; Herzegovina',
    'Botswana',
    'Brazil',
    'British Virgin Islands',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Cape Verde',
    'Cayman Islands',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    'Cote D Ivoire',
    'Croatia',
    'Cruise Ship',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Polynesia',
    'French West Indies',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kuwait',
    'Kyrgyz Republic',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Norway',
    'Oman',
    'Pakistan',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Pierre &amp; Miquelon',
    'Samoa',
    'San Marino',
    'Satellite',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'South Africa',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'St Kitts &amp; Nevis',
    'St Lucia',
    'St Vincent',
    'St. Lucia',
    'Sudan',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    "Timor L'Este",
    'Togo',
    'Tonga',
    'Trinidad &amp; Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks &amp; Caicos',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Venezuela',
    'Vietnam',
    'Virgin Islands (US)',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ]
}

export function getChargeInDollars(chargeInCents = 0) {
  let chargeInDollars = chargeInCents / 100
  chargeInDollars = chargeInDollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

  return chargeInDollars
}

export function splitIntoCodeAndNumber(contactNumber = '') {
  contactNumber = _.trim(contactNumber)
  const split = _.split(contactNumber, ' ', 2)
  let contactNumberSplit = { code: 'us', number: '' }
  if (split.length === 2)
    contactNumberSplit = {
      code: contactNumber.substr(0, contactNumber.indexOf(' ')),
      number: contactNumber.substr(contactNumber.indexOf(' ') + 1),
    }
  return contactNumberSplit
}

/**
 * Gets a cookie value by name
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string|null} The cookie value or null if not found
 */
export const getCookie = name => {
  const cookies = document.cookie.split(';')
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim()
    if (cookie.startsWith(`${name}=`)) {
      return decodeURIComponent(cookie.substring(name.length + 1))
    }
  }
  return null
}

export function checkIfPlanExpired(planID = '') {
  let isExpiredPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.expiredPlanIDList, planID)) {
      isExpiredPlan = true
    }
  }

  return isExpiredPlan
}

export function getTimestampAsHumanDate(timestamp = 0) {
  let formattedDate = ''
  if (timestamp > 0) {
    const d = new Date(timestamp)
    formattedDate = _.join([d.getDate(), d.getMonth() + 1, d.getFullYear()], '/')
  }
  return formattedDate
}

export function getTimestampAsFullHumanDate(timestamp = 0) {
  let formattedDate = ''
  if (timestamp > 0) {
    const d = new Date(timestamp * 1000)
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]
    formattedDate = _.join([d.getDate(), months[d.getMonth()], d.getFullYear()], ' ')
  }
  return formattedDate
}

export function getTimestampAsFullHumanDateOrdinal(timestamp = 0) {
  let formattedDate = ''
  if (timestamp > 0) {
    const d = new Date(timestamp * 1000)
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]
    let ordinal = 'th'
    if (d.getDate() % 10 === 1 && d.getDate() !== 11) ordinal = 'st'
    else if (d.getDate() % 10 === 2 && d.getDate() !== 12) ordinal = 'nd'
    else if (d.getDate() % 10 === 3 && d.getDate() !== 13) ordinal = 'rd'

    formattedDate = _.join(
      [months[d.getMonth()], _.join([d.getDate(), ordinal], ''), d.getFullYear()],
      ' ',
    )
  }
  return formattedDate
}

export function getMetricTimestampAsFullHumanDate(timestamp = 0) {
  let formattedDate = ''
  if (timestamp > 0) {
    const d = new Date(timestamp)
    const months = [
      'Jan',
      'Febr',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    formattedDate = _.join([d.getDate(), months[d.getMonth()]], ' ')
  }
  return formattedDate
}

export function getMetricTimestampInHours(timestamp = 0) {
  let formattedDate = ''
  if (timestamp > 0) {
    const d = new Date(timestamp)
    let hours = d.getHours()
    const ampm = hours >= 12 ? ' pm' : ' am'
    hours %= 12
    if (!hours) hours = 12
    formattedDate = _.join([hours, ampm], '')
  }
  return formattedDate
}

export function getMetricDayTimestamp(timestamp = 0) {
  let day = 0
  if (timestamp > 0) {
    const d = new Date(timestamp)

    day = d.getUTCDate()
  }
  return day
}

export function getMetricMonthTimestamp(timestamp = 0) {
  let monthDigit = 0
  if (timestamp > 0) {
    const d = new Date(timestamp)

    monthDigit = d.getUTCMonth()
  }
  return monthDigit
}

export function getMetricLocalMonthTimestamp(timestamp = 0) {
  let monthDigit = 0
  if (timestamp > 0) {
    const d = new Date(timestamp)

    monthDigit = d.getMonth()
  }
  return monthDigit
}

export function getMetricMonthNameTimestamp(timestamp = 0) {
  let month = '-'

  if (timestamp > 0) {
    const d = new Date(timestamp)

    const monthDigit = d.getUTCMonth()
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    month = months[monthDigit]
    month = `${month}'20`
  }
  return month
}

export function getTimestampOfMonth(monthsPrevious = 0, setDateValue = 2) {
  const d = new Date()
  const m = d.getUTCMonth()
  d.setMonth(d.getUTCMonth() - monthsPrevious)

  // If still in same month, set date to last day of
  // previous month
  if (d.getUTCMonth() === m) d.setDate(0)
  d.setHours(0, 0, 0)
  d.setMilliseconds(0)
  d.setDate(setDateValue)

  // Get the time value in milliseconds and convert to seconds
  return d / 1000
}

export function getMetricYearTimestamp(timestamp = 0) {
  let year = 0
  if (timestamp > 0) {
    const d = new Date(timestamp)

    year = d.getUTCFullYear()
  }
  return year
}

export function getMetricHoursTimestamp(timestamp = 0) {
  let hour = -1
  if (timestamp > 0) {
    const d = new Date(timestamp)

    hour = d.getUTCHours()
  }
  return hour
}
export function getMetricMinutesTimestamp(timestamp = 0) {
  let minute = -1
  if (timestamp > 0) {
    const d = new Date(timestamp)

    minute = d.getUTCMinutes()
  }
  return minute
}

export function getMetricTimestampAsFullHumanDate2(timestamp = 0) {
  let formattedDate = ''
  if (timestamp > 0) {
    const d = new Date(timestamp)
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]
    formattedDate = _.join([d.getDate(), months[d.getMonth()], d.getFullYear()], ' ')
  }
  return formattedDate
}

export function getMetricMonthFromTimestamp(timestamp = 0) {
  let monthName = ''
  if (timestamp > 0) {
    const d = new Date(timestamp)
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    monthName = months[d.getMonth()]
  }
  return monthName
}

export function getMetricMonthFromMonthNo(monthNo = 0) {
  let monthName = ''
  if (monthNo > 0) {
    const months = [
      '',
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    monthName = months[monthNo]
  }
  return monthName
}

export function getCustomerGravatar(email = '') {
  let gravatarURL = 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y&s=40'
  email = _.trim(email)
  if (email && email.length) {
    email = _.toLower(email)

    email = _md5(email)
    gravatarURL = `https://www.gravatar.com/avatar/${email}?d=mp&s=40`
  }
  return gravatarURL
}

export function checkIfOldPlan(planID = '') {
  let isOldPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.olderPlansIDList, planID)) {
      isOldPlan = true
    }
  }

  return isOldPlan
}

export function checkIfPlanUpgradeOrDowngrade(currentPlanID = '', newPlanID = '') {
  let upgradeOrDowngrade = 'plan_subscribe'
  const currentPlanIndex = _.indexOf(constants.nonCustomPlansIDList, currentPlanID)
  const newPlanIndex = _.indexOf(constants.nonCustomPlansIDList, newPlanID)
  if (currentPlanIndex > 0 && newPlanIndex > 0) {
    if (currentPlanIndex < newPlanIndex && checkIfPhase4ActivePlan(currentPlanID)) {
      upgradeOrDowngrade = 'plan_upgrade'
    } else upgradeOrDowngrade = 'plan_downgrade'
  }
  return upgradeOrDowngrade
}

export function checkIfPlanIncludesTeamFeature(app = []) {
  let isTeamFeatureAllowed = false
  if (!checkIfFeatureRestricted(app, 'team_management')) {
    isTeamFeatureAllowed = true
  }
  return isTeamFeatureAllowed
}

export function checkIfTeamManagementIsSupported(app = []) {
  let isTeamManagementSupported = false
  if (
    app.id !== undefined &&
    (getAppEndpointVersion(app) === 'v2.0' || getAppEndpointVersion(app) === 'v3.0') &&
    checkIfPlanIncludesTeamFeature(app)
  ) {
    isTeamManagementSupported = true
  }

  return isTeamManagementSupported
}

export function isAppOwner(app = []) {
  let IsAppOwner = false
  if (app.role !== undefined && _.toLower(app.role) === constants.teamRoles.owner) {
    IsAppOwner = true
  }
  return IsAppOwner
}

export function isAppAdmin(app = []) {
  let IsAppAdmin = false
  if (app.role !== undefined && _.toLower(app.role) === constants.teamRoles.admin) {
    IsAppAdmin = true
  }
  return IsAppAdmin
}

export function isAppModerator(app = []) {
  let IsAppModerator = false
  if (app.role !== undefined && _.toLower(app.role) === constants.teamRoles.moderator) {
    IsAppModerator = true
  }
  return IsAppModerator
}

export function isAppDeveloper(app = []) {
  let IsAppDeveloper = false
  if (app.role !== undefined && _.toLower(app.role) === constants.teamRoles.developer) {
    IsAppDeveloper = true
  }
  return IsAppDeveloper
}

export function checkIfPlanIncludesAnalyticsFeature(app = []) {
  let isAnalyticsFeatureAllowed = false
  if (!checkIfFeatureRestricted(app, 'usage_analytics')) {
    isAnalyticsFeatureAllowed = true
  }
  return isAnalyticsFeatureAllowed
}

export function checkIfAnalyticsIsSupported(app = []) {
  let isAnalyticsIsSupported = false
  if (
    app.id !== undefined &&
    (getAppEndpointVersion(app) === 'v2.0' || getAppEndpointVersion(app) === 'v3.0') &&
    checkIfPlanIncludesAnalyticsFeature(app)
  ) {
    isAnalyticsIsSupported = true
  }
  return isAnalyticsIsSupported
}
export function definedErrorCodes(errorCode = '') {
  let errorCodeDefined = false
  const errorCodes = [
    'AUTH_ERR_TOKEN_EXPIRED',
    'AUTH_ERR_TOKEN_INVALID',
    'AUTH_ERR_AUTH_FAILED',
    'AUTH_ERR_TOKEN_BLACKLISTED',
    'ERR_TOO_MANY_DIRECT_REQUESTS',
  ]
  if (_.includes(errorCodes, errorCode)) {
    errorCodeDefined = true
  }
  return errorCodeDefined
}

export function handleErrors(errorCode = '', actionURL = 'non-auth') {
  let errorMsgs = {
    message: 'Something went wrong',
    description: 'Please refresh page and try again.',
  }
  const bearerTokenErrorCodes = [
    'AUTH_ERR_TOKEN_EXPIRED',
    'AUTH_ERR_TOKEN_INVALID',
    'AUTH_ERR_AUTH_FAILED',
  ]
  const tokenInvalidatedErrorCodes = ['AUTH_ERR_TOKEN_BLACKLISTED']
  const authLimitErrorCodes = ['ERR_TOO_MANY_DIRECT_REQUESTS']
  if (_.includes(bearerTokenErrorCodes, errorCode)) {
    errorMsgs = { message: 'Session expired', description: 'Please login again to continue.' }
  } else if (_.includes(tokenInvalidatedErrorCodes, errorCode)) {
    if (actionURL === 'auth') {
      errorMsgs = {
        message: 'Account profile updated successfully',
        description:
          'Account profile updated successfully! Please login with updated account details to continue.',
      }
    } else {
      errorMsgs = { message: 'Session expired', description: 'Please login again to continue.' }
    }
  } else if (_.includes(authLimitErrorCodes, errorCode)) {
    if (actionURL === 'signup') {
      errorMsgs = {
        message: 'Signup requests exceeded',
        description:
          'You have reached the maximum signup requests allowed in an hour. Please try signing up after sometime.',
      }
    } else if (actionURL === 'login') {
      errorMsgs = {
        message: 'Login requests exceeded',
        description:
          'You have reached the maximum login requests allowed in an hour. Please try logging in after sometime.',
      }
    } else {
      errorMsgs = {
        message: 'Reset requests exceeded',
        description:
          'You have reached the maximum reset password requests allowed in an hour. Please try again after sometime.',
      }
    }
  }
  return errorMsgs
}
export function isAuthErrorCode(errorCode = '') {
  let checkIfAuthTokenErrorCode = false
  const bearerTokenErrorCodes = [
    'AUTH_ERR_TOKEN_EXPIRED',
    'AUTH_ERR_TOKEN_INVALID',
    'AUTH_ERR_AUTH_FAILED',
    'AUTH_ERR_TOKEN_BLACKLISTED',
  ]
  if (_.includes(bearerTokenErrorCodes, errorCode)) {
    checkIfAuthTokenErrorCode = true
  }
  return checkIfAuthTokenErrorCode
}
export function ifValidImageURL(url) {
  return url.match(/\.(jpeg|jpg|gif|png|svg)$/) != null
}

export function checkIfPhase3ActivePlan(planID = '') {
  let isPhaseThreePlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.phase3PlansIDList, planID)) {
      isPhaseThreePlan = true
    }
  }

  return isPhaseThreePlan
}

export function checkIfFreePlan(planID = '') {
  let isFreePlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (constants.phase3PlanFreeIDCategories.appDeveloper === planID) {
      isFreePlan = true
    }
  }

  return isFreePlan
}
export function checkIfFreeEventPlan(planID = '') {
  let isFreePlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (constants.phase3PlanFreeIDCategories.eventOrganizer === planID) {
      isFreePlan = true
    }
  }

  return isFreePlan
}

export function getAppEndpointVersion(app = []) {
  // let version = 'v2.0'
  let version = 'v3.0'
  if (app.version !== undefined) {
    if (app.version === '1') version = 'v1.8'
    else if (app.version === '3') version = 'v3.0'
    else if (app.version === '2') version = 'v2.0'
  }

  return version
}

export function checkIfFeatureRestricted(app = [], featureSlug = '') {
  let isFeatureRestricted = true
  if (
    app.id !== undefined &&
    featureSlug !== '' &&
    constants.featureSlugList[featureSlug] !== undefined
  ) {
    const appPrarameterSlug = constants.featureSlugList[featureSlug]
    if (
      app.parameters !== undefined &&
      app.parameters[appPrarameterSlug] !== undefined &&
      app.parameters[appPrarameterSlug]
    ) {
      isFeatureRestricted = false
    }
  }
  return isFeatureRestricted
}

export function checkIfPhaseOneLegacyPlan(planID = '') {
  let isPhaseOneLegacyPlan = false
  if (planID.length) {
    if (_.includes(['meteoroid-(10-19)', 'asteroid-(10-19)'], planID)) {
      isPhaseOneLegacyPlan = true
    }
  }

  return isPhaseOneLegacyPlan
}

export function getAppHost(appSettings = []) {
  let appHost = 'api.cometchat.com'
  if (appSettings.ADMIN_API_HOST !== undefined) {
    appHost = appSettings.ADMIN_API_HOST
  }
  return appHost
}

export function getAppMetricHost(appSettings = []) {
  let appHost = constants.isLiveEnv
    ? `metrics-${appSettings.REGION}.cometchat.io`
    : `metrics-${appSettings.REGION}.cometchat-staging.com`

  if (appSettings.ANALYTICS_HOST !== undefined) {
    appHost = appSettings.ANALYTICS_HOST
  }
  return appHost
}

export function getAppCallsHost(appSettings = []) {
  const appHost = constants.isLiveEnv
    ? `call-${appSettings.REGION}.cometchat.io`
    : `call-${appSettings.REGION}.cometchat-staging.com`

  return appHost
}

export function validatePasswordStrength(password = '') {
  const strongRegex = new RegExp('^(?=.{14,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$', 'g')
  const goodRegex = new RegExp(
    '^(?=.{10,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$',
    'g',
  )
  const fairRegex = new RegExp(
    '^(?=.{8,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$',
    'g',
  )
  const enoughRegex = new RegExp('(?=.{6,}).*', 'g')
  let strength = 'weak'
  if (password.length === 0) {
    strength = 'weak'
  } else if (enoughRegex.test(password) === false) {
    strength = 'weak'
  } else if (strongRegex.test(password)) {
    strength = 'strong'
  } else if (goodRegex.test(password)) {
    strength = 'good'
  } else if (fairRegex.test(password)) {
    strength = 'fair'
  }

  return strength
}

export function getAppChatAPIEndpoint(app = []) {
  let endpoint = ''
  if (app.id !== undefined) {
    endpoint = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    if (app.version === '3') {
      endpoint = `${endpoint}${app.id}.api-${app.region}.cometchat.io/v3`
    } else if (app.version === '2') {
      endpoint = `${endpoint}api-${app.region}.cometchat.io/v2`
    }
  }
  return endpoint
}

export function formatDateIntoMDY(timestamp = false, position = 7) {
  let formattedDate = '-'
  if (timestamp) {
    const parsedTimestamp =
      String(timestamp).length > 10 ? parseInt(timestamp, 10) : parseInt(timestamp, 10) * 1000
    formattedDate = new Date(parsedTimestamp).toString().slice(3, 15)
    formattedDate = [formattedDate.slice(0, position), ',', formattedDate.slice(position)].join('')
  }
  return formattedDate
}
export function formatTimestampToHoursMins(timestamp = false) {
  let formattedTime = '00:00'
  if (timestamp) {
    const baseTimestamp = parseInt(timestamp, 10)
    const parsedTimestamp = String(timestamp).length > 10 ? baseTimestamp : baseTimestamp * 1000
    let h = new Date(parsedTimestamp).getHours()
    h = h < 10 ? ['0', h].join('') : h
    let m = new Date(parsedTimestamp).getMinutes()
    m = m < 10 ? ['0', m].join('') : m
    formattedTime = [h, m].join(':')
  }
  return formattedTime
}

export function formatTimestampComplete(timestamp, use24Hour = false) {
  const date = new Date(timestamp * 1000)

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]

  const day = String(date.getDate()).padStart(2, '0')
  const month = monthNames[date.getMonth()]
  const year = date.getFullYear()
  const hour24 = String(date.getHours()).padStart(2, '0')
  const hour12 = date.getHours() % 12 || 12
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const meridian = date.getHours() >= 12 ? 'PM' : 'AM'

  if (use24Hour) {
    return `${month} ${day}, ${year}, ${hour24}:${minutes}`
  }
  return `${month} ${day}, ${year}, ${hour12}:${minutes} ${meridian}`
}

export function checkIfPhase4ActivePlan(planID = '') {
  let isPhaseFourPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.phase4PlansIDList, planID)) {
      isPhaseFourPlan = true
    }
  }

  return isPhaseFourPlan
}

export function checkIfPhase5ActivePlan(planID = '') {
  let isPhaseFivePlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.phase5PlansIDList, planID)) {
      isPhaseFivePlan = true
    }
  }

  return isPhaseFivePlan
}

export function checkIfPlanCancellationDisabled(app = []) {
  let isPlanCancellationDisabled = false
  if (app.id !== undefined && app['plan.cancellation.disabled'] !== undefined) {
    isPlanCancellationDisabled = app['plan.cancellation.disabled']
  }
  return isPlanCancellationDisabled
}

export function getProcessedPriceStr(price) {
  /*
    If
      price = 123.999, returns "123.4"
      price = 123.99, returns "123.99"
      price = 890, returns "890"
  */
  const newPrice = Math.ceil(price * 100) / 100
  if (newPrice !== Math.trunc(newPrice)) {
    return newPrice.toFixed(2)
  }
  return String(newPrice)
}

function getEmptyStrIfNotAStr(arg) {
  return typeof arg === 'string' ? arg : ''
}

function addToObjIfNumber(valueToTest, obj, key) {
  if (typeof valueToTest === 'number') {
    obj[key] = valueToTest
  }
}

function getTransformedOptions(fetchedOptions) {
  const transformedOptions = []
  for (let i = 0; i < fetchedOptions.length; i += 1) {
    const fetchedOption = fetchedOptions[i]
    const transformedOption = {}
    transformedOption.id = getEmptyStrIfNotAStr(fetchedOption.id)
    transformedOption.name = getEmptyStrIfNotAStr(fetchedOption.name)
    transformedOption.amount =
      typeof fetchedOption.amount === 'number' ? fetchedOption.amount : null
    transformedOption.mau = fetchedOption.tier
    transformedOption.isAnnual = Boolean(fetchedOption.isAnnual)
    const toAdd = ['discountedAmount', 'monthlyAmount', 'monthlyDiscountedAmount']
    for (let j = 0; j < toAdd.length; j += 1) {
      addToObjIfNumber(fetchedOption[toAdd[j]], transformedOption, toAdd[j])
    }
    if (typeof fetchedOption.monthlyDiscountPercent === 'string') {
      transformedOption.monthlyDiscountPercent = fetchedOption.monthlyDiscountPercent
    }
    transformedOptions.push(transformedOption)
  }
  return transformedOptions
}

export function transformFetchedPlanData(fetchedPlanData) {
  if (!fetchedPlanData || typeof fetchedPlanData !== 'object') {
    return null // Can't transform fetched plans as the data is different than expected
  }
  const res = {}
  const { annualDiscountPercent, freePlans, ...otherFetchedPlanData } = fetchedPlanData
  if (typeof annualDiscountPercent === 'string') {
    res.paidPlansAnnualDiscountPercent = annualDiscountPercent
  }
  if (Array.isArray(freePlans)) {
    res.freePlans = freePlans
  }
  const otherFetchedPlanDataKeys = Object.keys(otherFetchedPlanData)
  const paidPlans = []
  for (let i = 0; i < otherFetchedPlanDataKeys.length; i += 1) {
    const otherFetchedPlanDataKey = otherFetchedPlanDataKeys[i]
    const fetchedPlan = fetchedPlanData[otherFetchedPlanDataKey]
    const transformedPlan = {
      id: getEmptyStrIfNotAStr(fetchedPlan.id),
      name: getEmptyStrIfNotAStr(fetchedPlan.name),
      description: getEmptyStrIfNotAStr(fetchedPlan.description),
      planIncludes: Array.isArray(fetchedPlan.planIncludes) ? fetchedPlan.planIncludes : [],
      isCustom: fetchedPlan.isCustom ? fetchedPlan.isCustom : false,
      baseMonthlyPrice: fetchedPlan.baseMonthlyPrice ? fetchedPlan.baseMonthlyPrice : undefined,
      baseAnnualPrice: fetchedPlan.baseAnnualPrice ? fetchedPlan.baseAnnualPrice : undefined,
    }
    const { monthly: monthlyOptions, annual: yearlyOptions } = fetchedPlan
    if (Array.isArray(monthlyOptions)) {
      transformedPlan.monthlyInfo = getTransformedOptions(monthlyOptions)
    }
    if (Array.isArray(yearlyOptions)) {
      transformedPlan.yearlyInfo = getTransformedOptions(yearlyOptions)
    }
    paidPlans.push(transformedPlan)
  }
  res.paidPlans = paidPlans
  return res
}

export function getPhase4PlansCostMapFromPaidPlans(paidPlans) {
  const res = new Map()
  for (let i = 0; i < paidPlans.length; i += 1) {
    const { monthlyInfo, yearlyInfo } = paidPlans[i]
    if (monthlyInfo) {
      for (let j = 0; j < monthlyInfo.length; j += 1) {
        const monthlyPlan = monthlyInfo[j]
        res.set(monthlyPlan.id, monthlyPlan.amount)
      }
    }
    if (yearlyInfo) {
      for (let j = 0; j < yearlyInfo.length; j += 1) {
        const yearlyPlan = yearlyInfo[j]
        res.set(yearlyPlan.id, yearlyPlan.discountedAmount ?? yearlyPlan.amount)
      }
    }
  }
  return res
}

export const checkBillingType = app => {
  let billingType = 'mau'
  if (app.parameters !== undefined && app.parameters['overages.dcu.enabled']) {
    billingType = 'dcu'
  } else if (app.parameters !== undefined && app.parameters['overages.mcu.enabled']) {
    billingType = 'mcu'
  }
  return billingType
}

export function showAppVersion(v) {
  let showVersion = false
  if (v === '2' || v === '1') showVersion = true

  return showVersion
}

export function getAppVersion(appVersion = '') {
  let version = 'v3.0'
  if (appVersion !== '') {
    if (appVersion === '1') version = 'v1.8 (Legacy)'
    else if (appVersion === '3') version = 'v3.0'
    else if (appVersion === '2') version = 'v2.0'
  }

  return version
}
/* 
This function compares the `object` and `base` objects, and returns a new 
object that includes only the properties that are different in the `object` 
compared to the `base`. Comparison is performed recursively which means that 
it can handle nested objects.
 */
export function compareObjectsAndReturnKeyDiffs(object, base) {
  return _.transform(object, (result, value, key) => {
    if (!_.isEqual(value, base[key])) {
      result[key] =
        _.isObject(value) && _.isObject(base[key])
          ? compareObjectsAndReturnKeyDiffs(value, base[key])
          : value
    }
  })
}
export function canListInvoices(app = '') {
  let listInvoices = true
  let planID = app.plan
  const checkIfChildApp = 'parent' in app

  planID = _.toLower(_.trim(planID))

  if (checkIfChildApp || (planID.length && constants.developerPlanID === planID)) {
    listInvoices = false
  }

  return listInvoices
}

export function appNavCheckIfAppAdmin(app = []) {
  let IsAppAdmin = true
  if (app.role !== undefined && _.toLower(app.role) !== constants.teamRoles.admin) {
    IsAppAdmin = false
  }
  return IsAppAdmin
}

export function appNavCheckIfAppOwner(app = []) {
  let IsAppOwner = true
  if (app.role !== undefined && _.toLower(app.role) !== constants.teamRoles.owner) {
    IsAppOwner = false
  }
  return IsAppOwner
}

export function checkIfPlanIsRestrictedToUpgrade(planID = '') {
  let isRestrictedToUpgrade = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.plansRestrictedToUpgrade, planID)) {
      isRestrictedToUpgrade = true
    }
  }

  return isRestrictedToUpgrade
}

export function checkIfFreeEmailDomain(email = '') {
  const freeEmailDomains = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'protonmail.com',
    'aol.com',
    'zoho.com',
    'mail.com',
    'yandex.com',
    'gmx.com',
    'icloud.com',
    'tutanota.com',
    'fastmail.com',
    'inbox.com',
    'hushmail.com',
    'lycos.com',
    'rediffmail.com',
    'mailfence.com',
    'temp-mail.org',
    'guerrillamail.com',
  ]
  // Extract the domain part of the email
  const domain = email.split('@')[1]

  // Check if the domain is in the list of free email domains
  return freeEmailDomains.includes(domain.toLowerCase())
}

export function getModerationRuleActionName(moderationRuleActionKey = '') {
  switch (moderationRuleActionKey) {
    case 'dropMessage':
      return 'Blocked Message'
    case 'block':
      return 'Block user'
    case 'ban':
      return 'Ban user from group'
    case 'kick':
      return 'Kick user from group'
    case 'blockMessage':
      return 'Blocked Message'
    case 'flagMessage':
      return 'Flagged Message'
    default:
      return moderationRuleActionKey
  }
}

export function objectToParams(obj) {
  const params = []
  _.forEach(obj, function fn(o, k) {
    const encodedKey = encodeURIComponent(k)

    const encodedValue = encodeURIComponent(obj[k])
    params.push(`${encodedKey}=${encodedValue}`)
  })

  return params.join('&')
}

export function replaceAll(str, find, replace) {
  return _.replace(str, new RegExp(_.escapeRegExp(find), 'g'), replace)
}

export function checkIfPhase6ActivePlan(planID = '') {
  let isPhaseSixPlan = false
  if (planID.length) {
    planID = _.toLower(_.trim(planID))
    if (_.includes(constants.phase6PlansIDList, planID)) {
      isPhaseSixPlan = true
    }
  }

  return isPhaseSixPlan
}

// add trailing 0 when decimal not upto 2 places

export function getUptoTwoDecimalPriceStr(price) {
  return price.toFixed(2)
}
export function encryptEmail(email) {
  const [username, domain] = email.split('@')
  const visibleUsername = username.slice(0, 4)
  const encryptedUsername = username.length > 4 ? `<span class='maskedEmailDot'>${'•'.repeat(username.length - 4)}</span>` : ''
  return `${visibleUsername}${encryptedUsername}@${domain}`
}

export function getFilteredExtensions(apps = {}, filterNotificationsIds = []) {
  const now = Math.floor(Date.now() / 1000)
  const filteredExtensions = apps.extensionsAllList.filter(extension => {
    const installedIndex = _.findIndex(apps.extensionsInstalledList, function fn(o1) {
      return o1.id === extension.id
    })
    let isInstalledAndEnabled = false

    if (
      apps.extensionsInstalledList[installedIndex] &&
      apps.extensionsInstalledList[installedIndex].enabled
    ) {
      isInstalledAndEnabled = true
    }
    if (
      (extension.endOfLifeAt && extension.endOfLifeAt < now) ||
      (!(installedIndex >= 0 && isInstalledAndEnabled) &&
        extension.markedAsLegacyAt &&
        extension.markedAsLegacyAt < now)
    ) {
      return false
    }
    return filterNotificationsIds.includes(extension.id)
  })
  return filteredExtensions
}

export function checkAndNavigateToAddBot(props, relativePath = '') {
  const { apps, dispatch, history } = props
  try {
    const { appSettings } = apps
    if (!appSettings?.parameters?.['features.ai.enabled']) {
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'visibleModalID',
          value: 'aiFeatures',
        },
      })
    } else {
      const appId = apps.active?.id || (typeof window !== 'undefined' ? (window.location.pathname.split('/')[2] || null) : null)
      if (appId) {
        history.push(`/app/${appId}${relativePath}`)
      }
    }
  } catch (error) {
    dispatch({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: `Failed to navigate: ${error.message}` },
    })
  }
}

/**
 * Extracts the builder ID from a path like: /app/:appId/builder/:builderId
 * Returns null if the builder ID is not present .
 */
export function getBuilderIdFromPath(pathname) {
  const pathParts = _.split(pathname, '/')
  // Case 1: Normal pattern — /apps/:appId/builder/:builderId
  if (pathParts[3] === 'builder') {
    return pathParts[4] ?? null
  }

  // Case 2: Fallback — search for 'builder' anywhere
  const builderIndex = pathParts.indexOf('deploy')
  if (builderIndex !== -1 && pathParts[builderIndex + 1]) {
    return pathParts[builderIndex + 1]
  }

  return null // No builder segment found
}

export function getNewVariantName(activeTab) {
  switch (activeTab) {
    case 'wordpress':
      return 'WP - Chat App'
    case 'html':
      return 'HTML - Chat App'
    case 'wix':
      return 'Wix - Chat App'
    case 'webflow':
      return 'Webflow - Chat App'
    case 'shopify':
      return 'Shopify - Chat App'
    case 'squarespace':
      return 'SqSp - Chat App'
    case 'php':
      return 'PHP - Chat App'
    case 'laravel':
      return 'Laravel - Chat App'
    case 'javascript':
      return 'JS - Chat App'
    case 'others':
      return 'Others - Chat App'
    case 'ai-agent':
      return 'AI Agent - Chat App'

    default:
      return 'Default - Chat App'
  }
}

export const updateGetStartedStep = (key, value) => {
  const storedData = localStorage.getItem('cc_getStartedScreenBehaviour')
  const getStartedStep = storedData ? JSON.parse(storedData) : {}
  const updatedStep = { ...getStartedStep, [key]: value }
  localStorage.setItem('cc_getStartedScreenBehaviour', JSON.stringify(updatedStep))
}

export const getGravatarForHeader = (email = '', size = 100) => {
  let userEmail = email
  if (!email || !email.length) {
    const localUserObj = localStorage.getItem('userData') || ''
    if (localUserObj.length) {
      const userObj = JSON.parse(localUserObj)
      if (userObj.user?.email !== undefined) {
        userEmail = userObj.user.email
      }
    }
  }
  const hash = _md5(userEmail.trim().toLowerCase())
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=mp`
}
